// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"87857a1b","162":"31cc016c","716":"f16b368e"}[chunkId] + ".chunk.js";
};